'use client'

import { HTMLProps, useEffect, useRef } from 'react'
import clsx from 'classnames'
import { useScroll, motion, useTransform } from 'framer-motion'
import { BackButton } from '@/shared/ui/breadcrumbs'
import { Text } from '@/shared/ui'
import style from './header-page.module.scss'

interface HeaderPageProps extends HTMLProps<HTMLDivElement> {
  title: string
  hasAnimation?: boolean
}

export const HeaderPage = ({ title, hasAnimation = true }: HeaderPageProps) => {
  const wrapperRef = useRef<HTMLDivElement>(null)
  const { scrollY } = useScroll({ target: wrapperRef, offset: ['end end', 'end start'] })
  const opacity = useTransform(scrollY, [0, 200], [1, 0])
  const transform = useTransform(scrollY, [0, 200], ['translateY(0px)', 'translateY(100px)'])

  return (
    <div className={style.headerWrapper}>
      <motion.header
        style={hasAnimation ? { opacity, transform } : {}}
        ref={wrapperRef}
        className={clsx(style.header, 'main-padding')}
      >
        <BackButton />
        <Text type="h1">{title}</Text>
      </motion.header>
    </div>
  )
}
